<script>
import {
  instancesSetting,
  setInstancesSetting
} from "@/service";

import _ from 'lodash';
import {alertComfirm} from "@/helpers/swal";
import {useVuelidate} from "@vuelidate/core";
import addCustomer from "@/views/energy-conf/components/add-customer.vue";
import moment from "moment"

export default {
  setup: () => ({ v$: useVuelidate() }),
  props: {
    type: {
      type: String,
      default: 'user', // user-普通用户 organization-企业用户
    },
    belong_id: {
      type: [String, Number],
      default: null,
    },
    belong_type: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      /* 分页start */
      tab_info_length: 0,
      page: 1,
      perPage: 10,
      prePageOption: [10, 20, 30, 40, 50],
      pages: [],
      /* 分页end */
      config: {
        altFormat: "Y-m-d",
        altInput: true,
        dateFormat: "Y-m-d",
      },
      date2: null,
      tableHeaders: [
        {
          name: 'name',
          label: this.$t('page.energy_consumption_management.data_name'),
          visible: true
        },
        {
          name: 'value',
          label: this.$t('page.energy_consumption_management.value'),
          visible: true
        },
        {
          name: 'unit',
          label: this.$t('page.work-order.device.unit'),
          visible: true
        },
        {
          name: 'updated_at',
          label: this.$t('Update time'),
          visible: true
        },

      ],
      loading: false,
      tableLoaded: false,
      dataList: [],
      count: 0,
      filters: {
        page: 1,
        page_size: 10,
        keyword: '',
        role_id: null,
        status: null,
        belong_id: this.belong_id,
        belong_type: this.belong_type,
      },
      filter_value: {
        keyword: '',
        role_id: null,
        status: null,
      },
      adding: false,
      editId: null,
      editIndex: null,
      addItem: {
        role_id: null,
        email: null,
        username: null,
        first_name: null,
        last_name: null,
        tel: null,
        belong_id: this.belong_id,
        belong_type: this.belong_type,
      },
      editItem: {},
      statusOptions: [
        { value: '1', label: this.$t('page.user.normal') },
        { value: '2', label: this.$t('page.user.freeze') },
      ]
    }
  },
  components: {
    addCustomer,
  },
  computed: {
    getAccounts() {
      return instancesSetting
    },

  },
  mounted() {
    this._getFirstPage()
  },

  methods: {
    // 新建
    add() {
      console.log(this.belong_type)
      this.$refs.addCustomer.open()
      for (let p in this.addItem) {
        if (['belong_id', 'belong_type'].includes(p)) {
          continue
        }
        this.addItem[p] = null
      }
      this.adding = true
      console.log('additem:',this.addItem)
    },
    // 保存添加
    addSave() {
      this.v$.addItem.$touch()
      if (this.v$.addItem.$invalid) {
        return
      }
      const params = _.cloneDeep(this.addItem)
      params.kc_account_id = new Date().getTime()
      this.createAccount(params).then(() => {
        this.$message.success(this.$t('base.add_success'))
        this._getFirstPage()
        this.$emit('added')
        this.adding = false
      }).catch(err => {
        console.log(err)
      })
    },
    // 冻结
    lock(item) {
      let is_active = !item.is_active
      alertComfirm(this.$t('base.Confirm to perform this operation?'),
          is_active ? this.$t('page.user.unfreeze_account') : this.$t('page.user.freeze_account')
      ).then(res => {
        if (res) {
          this.patchAccount({
            id: item.id,
            is_active: is_active
          }).then(() => {
            this._getFirstPage()
            this.$message.success(this.$t('base.operate_success'))
          })
        }
      })
    },
    // 编辑
    edit(item, index) {
      // console.log('editItem:', item)
      this.editId=item.name
      this.dataList[index].name = item.name
      this.dataList[index].value=item.value
      this.dataList[index].unit=item.unit
      this.dataList[index].updated_at=moment().format("YYYY-MM-DD HH:mm:ss")
    },
    // 取消编辑
    editCancel() {
      this.editItem = {}
      this.editId = null
      this.editIndex = null
      this._getFirstPage() //重新更新一遍
    },
    // 保存编辑
    editSave() {
      const list = _.cloneDeep(this.dataList)
      let params={
        key:"energy_conf",
        value:JSON.stringify(list)
      }
      setInstancesSetting(params).then(() => {
        this.editId=null
        this.$message.success("修改成功")
        this._getFirstPage()

      }).catch(err => {
        console.log(err)
      })
    },
    /* 设置分页选项 */
    setPages() {
      this.pages = [];
      this.tab_info_length = this.count;
      let numberOfPages = Math.ceil(this.count / this.perPage);
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    // 筛选
    doFilter () {
      this.orders = []
      const search = {
        keyword: null,
        status: null,
        role_id: null,
        belong_id: this.belong_id,
        belong_type: this.belong_type,
      }
      if (this.filter_value.keyword) {
        search['keyword'] = this.filter_value.keyword
      }
      if (this.filter_value.role_id) {
        search['role_id'] = this.filter_value.role_id
      }
      if (this.filter_value.status !== null) {
        search['status'] = this.filter_value.status == 2 ? false : true
      }
      this.filters = _.assign(this.filters, search)
      this._getFirstPage()
    },
    // 重置
    resetSearch() {
      this.filter_value = {
        keyword: null,
        role_id: null,
        status: null,
      }
      this.$refs.roleFilter.clearSelect()
      this.doFilter()
    },
    // 翻页
    pageChange(val) {
      this.filters.page = val
      this._getList()
    },
    // 设置每页条数
    pageSizeChange(val) {
      this.filters.page_size = val
      this._getFirstPage()
    },
    // 获取数据
    _getFirstPage() {
      this.filters.page = 1;
      this._getList()
    },
    _getList() {
      this.dataList = []
      this.filters.page_size = this.perPage
      this.loading = true
      this.getAccounts('energy_conf').then(res => {
        this.loading = false
        this.dataList =JSON.parse(res.payload.value)
        this.dataList.forEach(item => {
          item.name = this.$t(`page.energy_consumption_management['${item.name}']`)
        });
        console.log(this.dataList)
        this.setPages()
      }).catch(err => {
        console.log(err)
      })
    },

  },
};
</script>

<template>
  <div>
    <b-row>
      <b-col lg="12">
        <b-card id="orderList">
          <b-card-header  class="border-0">
            <h5 class="card-title mb-4">{{ $t('page.energy_consumption_management.title') }}</h5>
          </b-card-header>
          <b-card-body class="pt-0">
            <div>
              <div class="table-responsive table-card mb-1">
                <table class="table table-nowrap align-middle" id="orderTable">
                  <thead class="text-muted table-light">
                  <tr class="text-uppercase">
                    <template v-for="(item, index) in tableHeaders" :key="index">
                      <th v-show="item.visible">{{ item.label }}</th>
                    </template>
                    <th class="text-end" style="padding-right: 70px;">
                      {{ $t('base.operation') }}
                    </th>
                  </tr>
                  </thead>
                  <tbody class="list form-check-all">
                 <!-- <tr v-if="adding">
                    <td class="td-min-w">
                      <role-select :placeholder="$t('base.required')" :type="type" :belong_type="belong_type" @changed="value => addItem.role_id = value" :invalid="!!v$.addItem.role_id.$errors.length"></role-select>
                    </td>
                    <td>
                      <input type="text" class="form-control" :class="v$.addItem.username.$errors.length ? 'is-invalid' : ''"  v-model="addItem.username" :placeholder="$t('base.required')" />
                    </td>
                    <td class="td-min-w">
                      <div class="d-flex justify-content-between">
                        <input type="text" class="form-control me-2" :class="v$.addItem.first_name.$errors.length ? 'is-invalid' : ''" :placeholder="$t('also.last name')" v-model="addItem.first_name" />
                        <input type="text" class="form-control me-2" :class="v$.addItem.last_name.$errors.length ? 'is-invalid' : ''" :placeholder="$t('also.first name')" v-model="addItem.last_name" />
                      </div>
                    </td>
                    <td>
                      <input type="text" class="form-control" :class="v$.addItem.email.$errors.length ? 'is-invalid' : ''"  :placeholder="$t('base.required')" v-model="addItem.email" />
                    </td>
                    <td>
                      <input type="text" class="form-control" :class="v$.addItem.tel.$errors.length ? 'is-invalid' : ''"  :placeholder="$t('base.required')" v-model="addItem.tel" />
                    </td>
                    <td></td>
                    <td class="text-end">
                      <i class="ri-checkbox-circle-line me-3 text-primary fs-2 cursor-pointer" @click="addSave"></i>
                      <i class="ri-close-circle-line me-3 text-danger fs-2 cursor-pointer" @click="adding = false"></i>
                    </td>
                  </tr>-->
                  <tr v-for="(item, index) in dataList" :key="index">
                    <template v-for="(titleItem, titleIdx) in tableHeaders" :key="titleIdx">
                      <td v-show="titleItem.visible" :class="['type','name'].includes(titleItem.name) ? 'td-min-w' : ''">
                        <!--        显示            -->
                        <template v-if="editId != item.name">
                          <span>{{ item[titleItem.name] }}</span>
                        </template>
                        <!--         编辑           -->
                        <template v-else>
                          <input v-if="titleItem.name == 'name'" type="text" class="form-control" placeholder="" v-model="item['name']" disabled />
                          <input v-if="titleItem.name == 'value'" type="text" class="form-control"  :placeholder="$t('base.required')" v-model="item['value']" />
                          <input v-if="titleItem.name == 'unit'" type="text" class="form-control"  :placeholder="$t('base.required')" v-model="item['unit']" />
                        </template>
                      </td>
                    </template>
                    <!--          操作          -->
                    <td class="text-end" v-if="editId != item.name">
                      <i class="ri-edit-2-line fs-3 text-primary me-3 cursor-pointer" v-perm="'other.energy.config.post'" @click="edit(item, index)" ></i>
                      <!--<i class="ri-delete-bin-line fs-3 text-primary me-3 cursor-pointer" @click="deleteItem(item.id)"></i>-->
                    </td>
                    <td class="text-end" v-else>
                      <i class="ri-checkbox-circle-line me-3 text-primary fs-2 cursor-pointer" @click="editSave"></i>
                      <i class="ri-close-circle-line me-3 text-danger fs-2 cursor-pointer" @click="editCancel"></i>
                    </td>

                  </tr>
                  </tbody>
                </table>
              </div>

            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <Pagination
        v-if="tab_info_length"
        v-model:page="page"
        v-model:perPage="perPage"
        :pages="pages"
        :prePageOption="prePageOption"
        :tab_info_length="tab_info_length"
        @update:page="pageChange"
        @update:perPage="pageSizeChange"
        class="me-5 my-3"
    ></Pagination>
    <add-customer title="新建工程师" ref="addCustomer" @refresh="_getFirstPage"></add-customer>
  </div>

</template>
<style scoped>
.td-min-w {
  min-width: 220px;
}
</style>
